// extracted by mini-css-extract-plugin
export default {"MyCard":"MyCard_MyCard__eIzQ4"};